export const storageKeys = {
    TOKEN: "_t",
    TOKEN_RE: "_tr",
    USER: "_u",
    ROLE: "_r",
    BRANCH_SHOP: "_bs",
    BRANCH_SHOP_PHOTO: "_bsp",
    CONFIRMATION_DATA: "_cd",
    BOOKING_DATA: "_bd",
    IS_GROUP: "isGroup"
}

export const dataKeys = {
    REMEMBER: "_ru",
    PHOTO: "_p",
}